export default {
    user: {},
    progress: false,
    loginErrors: {}
}